const GlobalErrors = {
  1015: 'global.api.global_error.1015',
  1030: 'global.api.global_error.1030',
  10020: 'forbidden.session_expired',
  10021: 'forbidden.invalid_geolocation',
  10023: 'forbidden.invalid_on_site_security',
}

export default GlobalErrors
